import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import Selector from "../../../Selector";

function SearchBranchField({
   branches,
   mainGroup,
   className,
   getFilteredBranches,
   setFilteredBranches,
   filterState,
   filterRegionState
}) {
   const [filialSelect, setFilialSelect] = useState([])

   useEffect(() => {
      getFilteredBranches();
   }, [getFilteredBranches])

   useEffect(() => {
      const changeFilialSelect = () => {
         if(filterRegionState.length) {
            const filtred = branches.filter((branch) => filterRegionState
                  .filter((region) => {
                     if (region.value === 'all') {
                        return branch.region !== null
                     }
                     if (region.value === 'others') {
                        return branch.region === null
                     }
                     if (region.value === 'allFbz') {
                        return ['TORRE FBZ - GO', 'TORRE FBZ - MT NORTE', 'TORRE FBZ - MT SUDOESTE', 'TORRE FBZ - NORDESTE', 'TORRE FBZ - SUL'].includes(branch.region)
                     }
                     if (region.value === branch.region) {
                        return true
                     }

                     return false;
                  }).length
               ).map((branch) =>
               ({ label: `${branch.external_id} ${branch.name}`, value: branch.id, region: branch.region }))

            return setFilialSelect(filtred)
         }

         const newBranches = branches.map((branch) =>
            ({ label: `${branch.external_id} ${branch.name}`, value: branch.id, region: branch.region }))

         setFilialSelect(newBranches)
      }
      
      changeFilialSelect()
   }, [branches, filterRegionState])

   useEffect(() => {
      const updatedBranches = () => {
         if (filterState && filterRegionState.length) {
            const updatedFilteredBranches = filterState.filter((branch) => {
              return filterRegionState.some((region) => region.value === branch.region);
            });
    
            setFilteredBranches(updatedFilteredBranches)
          } 
      };

      updatedBranches()
      /* eslint-disable */
   }, [filterRegionState]);

   return (
      ["support", "backoffice", "transporter", "warehouse"].indexOf(mainGroup) !== -1 && (
         <Selector
            className={className}
            options={filialSelect}
            label="Selecionar a Filial Cargill"
            isMulti
            placeholder="Digite ou busque a filial..."
            value={filterState}
            onChange={(value) => {
               Array.isArray(value) ?
                  setFilteredBranches(value) :
                  value ? setFilteredBranches([value]) : setFilteredBranches([])
            }}
            defaultValue={filialSelect.length === 1 && filialSelect[0]}
            width="400px"
            data-cy="tabHeader-filterBranch-select"
            id="tabHeader-filterBranch-select"
         />
      )
   );
}

SearchBranchField.propTypes = {
   branches: PropTypes.array.isRequired,
   mainGroup: PropTypes.string.isRequired,
   filteredBranches: PropTypes.array,
   filterRegionState: PropTypes.array,
   onBranchSelected: PropTypes.func,
};

SearchBranchField.defaultProps = {
   branches: [],
};

const mapState = (state) => ({
   branches: state.branches.branches,
   filteredBranches: state.branches.filteredBranches,
   filterState: state.branches.filterState,
   filterRegionState: state.branches.filterRegionState
});

const mapDispatch = (dispatch) => ({
   setFilteredBranches: (payload) => dispatch.branches.setFiltered(payload),
   getFilteredBranches: (payload) => dispatch.branches.setFilteredAsync(payload)
});

export default connect(mapState, mapDispatch)(SearchBranchField);
